export default __webpack_public_path__ + "static/media/carro-de-la-compra.c0e3ca99.png";